<template>
  <div class="top-info">
    <div class="info-month">
      <div class="text-line">—</div>
      <div class="text-month">{{ dateInfo.month }}</div>
      <div class="text-line">—</div>
    </div>
    <div class="info-content">
      <div v-if="!isMin" class="info-arrow arrow-left" @click="clickPre"><span class="arrow"></span></div>
      <div class="info-side">
        <div class="text-one">{{ dateInfo.gzYMD.month }}</div>
        <div class="text-two">{{ dateInfo.gzYMD.day }}</div>
        <div class="text-one">{{ dateInfo.gzYMD.year }}</div>
      </div>
      <div class="info-mid">
        <div class="text-num" @click="clickDay">{{ dateInfo.day }}</div>
      </div>
      <div class="info-side">
        <div class="text-week">{{ dateInfo.week }}</div>
      </div>
      <div v-if="!isMax" class="info-arrow arrow-right" @click="clickNext"><span class="arrow"></span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopInfo',
  props: {
    dateInfo: {
      type: Object,
      required: true,
      validator(value) {
        if (!value) return false;
        const topKeys = ['month', 'day', 'week', 'gzYMD'];
        if (!topKeys.every(k => Object.prototype.hasOwnProperty.call(value, k))) return false;
        const gz = value.gzYMD || {};
        return ['year', 'month', 'day'].every(k => Object.prototype.hasOwnProperty.call(gz, k));
      }
    },
    isMin: {
      type: Boolean,
      default: false
    },
    isMax: {
      type: Boolean,
      default: false
    },
    preFunc: {
      type: Function,
      default() { return undefined }
    },
    dayFunc: {
      type: Function,
      default() { return undefined }
    },
    nextFunc: {
      type: Function,
      default() { return undefined }
    },
  },
  methods: {
    clickPre() {
      if(this.preFunc && typeof(this.preFunc) == 'function'){
        this.preFunc();
      }
    },
    clickNext() {
      if(this.nextFunc && typeof(this.nextFunc) == 'function'){
        this.nextFunc();
      }
    },
    clickDay() {
      if(this.dayFunc && typeof(this.dayFunc) == 'function'){
        this.dayFunc();
      }
    }
  }
};
</script>

<style scoped>
.top-info {
  padding-top: 1rem;
  color: #191919;
}
.info-month {
  text-align: center;
  display: flex;
  width: 45%;
  line-height: 3rem;
  margin: 0 auto;
}
.text-line {
  width: 30%;
  font-size: 2.25rem;
  font-weight: 100;
  line-height: 2.5rem;
  color: #979797;
}
.text-month {
  width: 40%;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 3rem;
  white-space: nowrap;
  word-break: keep-all;
}
.info-content {
  position: relative;
  text-align: center;
  display: flex;
  width: 100%;
  height: 6.8rem;
  margin-top: -0.5rem;
}
.info-side {
  width: 20%;
}
.info-mid {
  width: 60%;
}
.info-arrow {
  position: absolute;
  width: 2rem;
  height: 2rem;
  top: 2.4rem;
}
.info-arrow .arrow {
  width: 1rem;
  height: 1rem;
  margin-top: 0.5rem;
  display: inline-block;
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.info-arrow.arrow-left {
  left: -1.5rem;
}
.info-arrow.arrow-left .arrow {
  background-image: url('../../assets/images/dress/arrow-l.png');
}
.info-arrow.arrow-right {
  right: -1.5rem;
}
.info-arrow.arrow-right .arrow {
  background-image: url('../../assets/images/dress/arrow-r.png');
}
.text-num {
  font-size: 7rem;
  font-weight: bold;
  line-height: 7rem;
}
.text-one {
  color: #666;
  font-size: 0.95rem;
}
.text-two {
  font-size: 1.15rem;
  font-weight: bold;
  word-break: break-all;
  writing-mode: vertical-rl;
  writing-mode: tb-rl;
  text-align: center;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  padding: 0.15rem 0;
}
.text-week {
  float: right;
  font-size: 1.15rem;
  font-weight: bold;
  word-break: break-all;
  writing-mode: vertical-rl;
  writing-mode: tb-rl;
  text-align: center;
  display: flex;
  width: 2rem;
  flex-direction: column;
  justify-content: center;
  height: 6.5rem;
  padding: 0 0.25rem;
  margin: 0.25rem 1rem 0 0;
  word-spacing: 5px;
  border: solid 1px #ddd;
  border-radius: 0.25rem;
}
</style>
